import script from "./GeneralCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./GeneralCard.vue?vue&type=script&setup=true&lang=ts"

import "./GeneralCard.vue?vue&type=style&index=0&id=fd10a2dc&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/livoapp/LivoFrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd10a2dc"]])

export default __exports__